import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * @description Validates the email
 * @param {AbstractControl} control - The control to validate
 * @returns {ValidationErrors | null} The validation errors or null
 */
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) ? null : { invalidEmail: true };
  };
}
